import { Trans } from '@lingui/macro';
import { Menu, MenuItem } from '@mui/material';
import { SignOut, Gear, ArrowsLeftRight } from '@phosphor-icons/react/dist/ssr';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, Button } from 'components/button/Button';
import { Avatar } from 'components/avatar/Avatar';

interface UserAvatarProps {
  letters?: string;
  color?: string;
  onLogout?: () => void;
  showSwitchCompany?: boolean;
  onSwitchCompany?: () => void;
}

export const UserAvatar = ({
  color,
  letters,
  onLogout,
  showSwitchCompany,
  onSwitchCompany,
}: UserAvatarProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePersonalSettings = () => {
    handleClose();
    navigate('/personal-settings');
  };
  return (
    <>
      <BaseButton
        onClick={handleClick}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <Avatar letters={letters} color={color} />
      </BaseButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              ul: {
                padding: '8px',
                li: {
                  padding: 0,
                },
              },
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: '8px',
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
              button: {
                width: '100%',
                justifyContent: 'flex-start',
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handlePersonalSettings}>
          <Button startIcon={<Gear size={16} />} variant="tertiary" size="sm">
            <Trans>Personal settings</Trans>
          </Button>
        </MenuItem>
        {showSwitchCompany && (
          <MenuItem onClick={onSwitchCompany}>
            <Button startIcon={<ArrowsLeftRight size={16} />} variant="tertiary" size="sm">
              <Trans>Switch company</Trans>
            </Button>
          </MenuItem>
        )}
        <MenuItem onClick={onLogout}>
          <Button startIcon={<SignOut size={16} />} variant="tertiary" size="sm">
            <Trans>Log out</Trans>
          </Button>
        </MenuItem>
      </Menu>
    </>
  );
};
